import { render } from "./CancelReasonPopup.vue?vue&type=template&id=3972a30d&ts=true"
import script from "./CancelReasonPopup.vue?vue&type=script&lang=ts"
export * from "./CancelReasonPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__